"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemObjectDetails = exports.vendorObjectDetails = exports.invoiceObjectDetails = void 0;
const colors = __importStar(require("./colors"));
exports.invoiceObjectDetails = {
    date: { label: 'Invoice Date', color: colors.PURPLE },
    dueOn: { label: 'Invoice Due On', color: colors.ORANGE },
    number: { label: 'Invoice Number', color: colors.MAGENTA },
    grossAmount: { label: 'Invoice Gross Amount', color: colors.PURPLE_LIGHT },
    currency: { label: 'Invoice Currency', color: colors.SEA_BLUE },
};
exports.vendorObjectDetails = {
    name: { label: 'Vendor Name', color: colors.GREEN_DARK },
    address: { label: 'Vendor Address', color: colors.LIME_GREEN },
};
exports.itemObjectDetails = {
    name: { label: 'Item Name', color: colors.BLUE },
    quantity: { label: 'Item Quantity', color: colors.ORANGE_DARK },
    totalPrice: { label: 'Item Price', color: colors.HIGHLIGHT_RED },
    tax: { label: 'Item Tax Rate', color: colors.LIGHT_GREEN },
};
